// extracted by mini-css-extract-plugin
export default {"content":"HeroContent_content__9wZSA","title":"HeroContent_title__X-yEO","description":"HeroContent_description__25aJv","control":"HeroContent_control__OTu-z"};